import React from 'react';
import { COLORS } from '../../../config/designSystem/Colors';
import {Stack} from 'expo-router';
import { settingKey } from '../../../constants/routeKeys';
import { title } from '../../../components/Root/title';


export default function Layout(){
  return (
    <Stack
      initialRouteName={settingKey}
      screenOptions={({route}) => {
        return({
          headerShown: false,
          title: title(route.name),
          contentStyle: { backgroundColor: COLORS.surface.primary },
        });
      }}
    />
  );
}
